// src/components/ui/useGlobalModal.js
import { createContext, useContext, useState, useCallback } from 'react';
import { useEffect } from 'react';
const GlobalModalContext = createContext();

export function GlobalModalProvider({ children }) {
  const [modalState, setModalState] = useState({
    isOpen: false,
    title: '',
    message: '',
    variant: 'info', // info, success, warning, danger
    confirmText: 'Tak',
    cancelText: 'Anuluj',
    onConfirm: null,
    onCancel: null,
    hideCancel: false,
  });

  const openConfirm = useCallback(
    ({
      title = 'Potwierdzenie',
      message,
      confirmText = 'Tak',
      cancelText = 'Anuluj',
      onConfirm = () => {},
      onCancel = () => {},
      variant = 'danger',
      hideCancel = false,
    }) => {
      setModalState({
        isOpen: true,
        title,
        message,
        variant,
        confirmText,
        cancelText,
        onConfirm,
        onCancel,
        hideCancel,
      });
    },
    []
  );
 const close = useCallback(() => {
    setModalState((prev) => ({ ...prev, isOpen: false }));
  }, []);
  const openAlert = useCallback(
    ({ title = 'Informacja', message, variant = 'info', confirmText = 'OK', onConfirm = () => {} }) => {
      setModalState({
        isOpen: true,
        title,
        message,
        variant,
        confirmText,
        cancelText: '',
        onConfirm,
        onCancel: () => close(),
        hideCancel: true,
      });
    },
    [close]
  );

 

  return (
    <GlobalModalContext.Provider value={{ openConfirm, openAlert, close }}>
      {children}
      <GlobalModal {...modalState} onClose={close} />
    </GlobalModalContext.Provider>
  );
}

export const useGlobalModal = () => {
  const context = useContext(GlobalModalContext);
  if (!context) {
    throw new Error('useGlobalModal musi być używany wewnątrz GlobalModalProvider');
  }
  return context;
};

// ────────────────────────────────────────────────────────────────

function GlobalModal({
  isOpen,
  title,
  message,
  variant = 'info',
  confirmText,
  cancelText,
  onConfirm,
  onCancel,
  hideCancel,
  onClose,
}) {
useEffect(() => {
  if (!isOpen || variant !== 'success') return;

  const timer = setTimeout(() => {
    onClose();
  }, 2500);

  return () => clearTimeout(timer);
}, [isOpen, variant, onClose]);
  if (!isOpen) return null;

  const variants = {
    info: 'bg-blue-600',
    success: 'bg-green-600',
    warning: 'bg-amber-600',
    danger: 'bg-red-600',
  };

  const bgColor = variants[variant] || variants.info;
if (variant === 'success') {
    return (
      <div className="fixed top-6 right-6 z-50">
        <div className="flex items-start gap-3 px-5 py-4 rounded-lg shadow-xl bg-green-600 text-white max-w-sm">
          <div className="text-2xl leading-none">✅</div>

          <div>
            <p className="font-semibold">{title || 'Sukces'}</p>
            <p className="text-sm opacity-90">{message}</p>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center pt-20 bg-black/60">
      <div className="bg-white rounded-lg shadow-2xl max-w-md w-full mx-4 overflow-hidden">
        {/* Header */}
        <div className={`${bgColor} px-6 py-4 text-white`}>
          <h2 className="text-xl font-semibold">{title}</h2>
        </div>

        {/* Content */}
        <div className="p-6">
          <p className="text-gray-700 whitespace-pre-line">{message}</p>
        </div>

        {/* Buttons */}
        <div className="px-6 py-4 bg-gray-50 flex justify-end gap-3">
          {!hideCancel && (
            <button
              onClick={() => {
                onCancel?.();
                onClose();
              }}
              className="px-5 py-2.5 bg-gray-200 hover:bg-gray-300 rounded-md font-medium transition-colors"
            >
              {cancelText || 'Anuluj'}
            </button>
          )}

          <button
            onClick={() => {
              onConfirm?.();
              onClose();
            }}
            className={`px-5 py-2.5 text-white rounded-md font-medium transition-colors ${bgColor} hover:opacity-90`}
          >
            {confirmText || 'OK'}
          </button>
        </div>
      </div>
    </div>
  );
}